import styled from "styled-components"

import useCustomerEditModal from "hooks/useCustomerEditModal"

const Container = styled.div`
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #2db2c8;
  }
`

interface CustomerNameContainerProps {
  id: number | null
  name: string
  isInstalled: boolean
  showDashOnEmptyName?: boolean
  isVendor?: boolean
  showViewPort?: boolean
  onClick?: () => void
}

const CustomerNameContainer = ({
  id,
  name,
  showDashOnEmptyName,
  isInstalled,
  isVendor,
  showViewPort,
}: CustomerNameContainerProps) => {
  const { onShowEditCustomerModal, renderEditCustomerModal } = useCustomerEditModal(showViewPort)
  const handleCustomerClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    if (!id) return

    onShowEditCustomerModal(id)
  }

  const getCustomerName = () => {
    if (!isInstalled) {
      return ""
    }

    if (name && id) {
      return name
    }

    if (id) {
      return "Customer details"
    }

    return ""
  }

  const customerName = getCustomerName()

  if (showDashOnEmptyName && !customerName && !isVendor) {
    return <span>-</span>
  }

  if (isVendor && name) {
    return <span>{name || "-"}</span>
  }

  return (
    <>
      <Container onClickCapture={handleCustomerClick}>{customerName}</Container>
      {renderEditCustomerModal()}
    </>
  )
}

export default CustomerNameContainer
